import Immutable from 'seamless-immutable'
import * as actions from './actions'

export const initialState = Immutable.from({
  geoPreference: null,
})

const geoPicker = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.SET_GEO_PREFERENCE:
      return state.set('geoPreference', payload)
    default:
      return state
  }
}

export default geoPicker
